module.exports = __webpack_public_path__ + "img/mid-shift-icon-green.314c9c08.png";